/**
 * initialize parallax images
 */
function vzParallaxInit() {
/*  lax.init();*/
  if (typeof lax === 'undefined' || !document.querySelector('.js-parallax')) {
    return;
  }

  lax.addDriver("scrollY", function () {
    return window.scrollY;
  });

  lax.addElements(".js-parallax", {
    scrollY: {
      translateY: [
        ["elInY", "elOutY"],
        ["-elHeight/5", "elHeight/5"],
      ],
    },
  });
}
